// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsStandardSpecificCalculation_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 4H20V5.33333H12.6667V6H14V7.33333H12.6667V11.3333H14V12.6667H12.6667L12.6667 20H11.3333V18H10V16.6667H11.3333V12.6667H10V11.3333H11.3333V5.33333H4V4Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.179 19.2842C17.5023 19.2213 17.8048 19.0999 18.0749 18.9316L18.6941 19.3338L19.182 18.8795L18.8249 18.2332C19.049 17.925 19.2087 17.567 19.2842 17.179L20 17V16.3333L19.2842 16.1544C19.2213 15.8311 19.0999 15.5286 18.9316 15.2585L19.3338 14.6394L18.8795 14.1515L18.2333 14.5085C17.9251 14.2844 17.5671 14.1247 17.179 14.0492L17 13.3333H16.3333L16.1544 14.0492C15.831 14.1121 15.5286 14.2334 15.2584 14.4018L14.6393 13.9996L14.1514 14.4538L14.5084 15.1001C14.2843 15.4083 14.1247 15.7663 14.0492 16.1544L13.3333 16.3333V17L14.0492 17.179C14.1121 17.5023 14.2334 17.8047 14.4017 18.0749L13.9996 18.6939L14.4538 19.1818L15.1 18.8248C15.4082 19.049 15.7663 19.2087 16.1544 19.2842L16.3333 20H17L17.179 19.2842ZM18.1333 16.6667C18.1333 17.4767 17.4767 18.1333 16.6667 18.1333C15.8566 18.1333 15.2 17.4767 15.2 16.6667C15.2 15.8566 15.8566 15.2 16.6667 15.2C17.4767 15.2 18.1333 15.8566 18.1333 16.6667Z" class="svg-bg"/>
  <path d="M15.3333 7.33333H16.6667V8.66667H18V6H15.3333V7.33333ZM15.3333 11.3333V12.6667H18V10H16.6667V11.3333H15.3333ZM8.66667 10H7.33333V11.3333H6V14H7.33333V12.6667H8.66667V10ZM6 15.3333H7.33333V16.6667H8.66667V18H6V15.3333ZM10 6H7.33333V8.66667H8.66667V7.33333H10V6Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsStandardSpecificCalculation is a generated icon component.
 */
let IconRmsStandardSpecificCalculation = IconRmsStandardSpecificCalculation_1 = class IconRmsStandardSpecificCalculation extends IconBaseElement {
    render() {
        return html `${IconRmsStandardSpecificCalculation_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsStandardSpecificCalculation.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsStandardSpecificCalculation = IconRmsStandardSpecificCalculation_1 = __decorate([
    customElement('zui-icon-rms-standard-specific-calculation')
], IconRmsStandardSpecificCalculation);
export { IconRmsStandardSpecificCalculation };
